// extracted by mini-css-extract-plugin
export var content = "_n5-1";
export var fullScreen = "_n5-0";